import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

const UrgencySection = () => {
  const threats = [
    { type: "Ransomware Attack", target: "Credit Union in Texas", time: "2 min ago", severity: "critical" },
    { type: "Phishing Email", target: "Investment Firm in NY", time: "5 min ago", severity: "high" },
    { type: "Data Breach Attempt", target: "Mortgage Company in CA", time: "8 min ago", severity: "critical" },
    { type: "Malware Detection", target: "Financial Advisor in FL", time: "12 min ago", severity: "medium" }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-red-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-alarm-warning-line text-lg"></i>
            Time-Sensitive Alert
          </div>
          
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Don't Wait for a Breach to Take Action
          </h2>
          
          <p className="text-xl text-gray-700 mb-8">
            The average cost of a data breach in 2024 is <strong>$4.88 million</strong>. 
            Every day without proper cybersecurity controls increases your risk exposure and potential regulatory penalties.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100">
              <div className="text-3xl font-bold text-red-600 mb-2">60%</div>
              <p className="text-gray-700">of small businesses close within 6 months of a cyber attack</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100">
              <div className="text-3xl font-bold text-red-600 mb-2">$1M+</div>
              <p className="text-gray-700">Average regulatory fine for non-compliance with DFS Section 500</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100">
              <div className="text-3xl font-bold text-red-600 mb-2">24hrs</div>
              <p className="text-gray-700">Required notification timeframe for cybersecurity events under DFS rules</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/risk-assessment"
              className="inline-flex items-center justify-center gap-2 bg-red-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Schedule Assessment
              <i className="ri-arrow-right-line"></i>
            </a>
            <a 
              href="/schedule-call"
              className="inline-flex items-center justify-center gap-2 bg-white text-red-600 px-8 py-4 rounded-lg font-semibold hover:bg-red-50 border-2 border-red-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Protected Now
              <i className="ri-shield-check-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UrgencySection;
